// Recovered compiled webpack factory 12623. Edit this function expression; run npm run build.
(e, t, r) => {
  r.d(t, { q: () => n });
  var a = r(95155);
  function n(e) {
    let { className: t = "" } = e;
    return (0, a.jsx)("span", {
      className: `font-['GeistMono','Geist_Mono',ui-monospace,monospace] inline-flex shrink-0 items-center squircle-sm border border-[#FD6421]/20 bg-[#FD6421]/[0.08] px-1.5 py-[3px] text-[9px] font-medium leading-none tracking-[0.12em] text-[#FD6421] normal-case dark:border-[#FD6421]/25 dark:bg-[#FD6421]/[0.12] dark:text-[#ff8a4c] ${t}`,
      children: "BETA",
    });
  }
}
